import { PieChart, Pie, Cell, Tooltip, ResponsiveContainer } from 'recharts';

function ServiceLevelChart({ data }) {
  if (!data || data.totalCalls === 0) {
    return (
      <div style={{
        display: 'flex', 
        alignItems: 'center', 
        justifyContent: 'center',
        height: '100%', 
        color: 'var(--text-muted)', 
        fontSize: '14px'
      }}>
        No service level data available
      </div>
    );
  }

  const chartData = [
    { name: 'Answered ≤60s', value: data.answeredWithin60s, color: '#0a72e7' },
    { name: 'Answered >60s', value: data.notAnsweredWithin60s, color: '#ef4444' }
  ];

  return (
    <div style={{ 
      display: 'flex', 
      flexDirection: 'column', 
      alignItems: 'center', 
      height: '100%',
      justifyContent: 'space-between'
    }}>
      {/* Top: percentage display */}
      <div style={{ textAlign: 'center', flexShrink: 0, marginBottom: '8px' }}>
        <div style={{
          fontSize: '28px', 
          fontWeight: '700',
          color: data.percentage >= 80 ? '#10b981' : data.percentage >= 60 ? '#f59e0b' : '#ef4444',
          lineHeight: 1.2
        }}>
          {data.percentage}%
        </div>
        <div style={{ fontSize: '12px', color: 'var(--text-muted)', marginTop: '2px' }}>
          {data.answeredWithin60s} of {data.totalCalls} calls
        </div>
      </div>

      {/* Middle: chart with explicit height */}
      <div style={{ 
        width: '100%', 
        flex: 1, 
        minHeight: 0,
        position: 'relative'
      }}>
        <ResponsiveContainer width="100%" height="100%">
          <PieChart>
            <Pie 
              data={chartData} 
              cx="50%" 
              cy="50%" 
              innerRadius={45} 
              outerRadius={70} 
              paddingAngle={4} 
              dataKey="value"
            >
              {chartData.map((entry, index) => (
                <Cell key={`cell-${index}`} fill={entry.color} />
              ))}
            </Pie>
            <Tooltip 
              contentStyle={{
                background: 'white', 
                border: '1px solid var(--border)',
                borderRadius: 'var(--radius-sm)', 
                boxShadow: 'var(--shadow-md)', 
                fontSize: '13px'
              }} 
              formatter={(value, name) => [`${value} calls`, name]} 
            />
          </PieChart>
        </ResponsiveContainer>
      </div>

      {/* Bottom: legend */}
      <div style={{ 
        display: 'flex', 
        gap: '16px', 
        marginTop: '8px',
        flexShrink: 0
      }}>
        {chartData.map(item => (
          <div key={item.name} style={{ display: 'flex', alignItems: 'center', gap: '6px' }}>
            <div style={{
              width: '10px', 
              height: '10px', 
              borderRadius: '50%', 
              background: item.color 
            }} />
            <span style={{ fontSize: '12px', color: 'var(--text-secondary)' }}>
              {item.name}
            </span>
          </div>
        ))}
      </div>
    </div>
  );
}

export default ServiceLevelChart;

